import './SuggestionsOverlay.css';
import '../../../core/components/app-root/AppRoot.css';
import '../../../core/styles/virtualFocus.css';
import './Suggestion.css';
export var defaultSuggestion = '_1smjoa1b-3-5-0';
export var icon = '_1smjoa10-3-5-0';
export var pastingSuggestion = '_1smjoa1e-3-5-0';
export var searchSuggestion = '_1smjoa1c-3-5-0';
export var statementSuggestionValue = '_1smjoa1d-3-5-0';
export var suggestion = '_1smjoa13-3-5-0';
export var suggestionContent = '_1smjoa14-3-5-0';
export var suggestionText = '_1smjoa15-3-5-0';
export var suggestionsEmptyState = '_1smjoa16-3-5-0';
export var suggestionsJSONPathHint = '_1smjoa17-3-5-0';
export var suggestionsLoading = '_1smjoa18-3-5-0';
export var tooltipWrapper = '_1smjoa1a-3-5-0';
export var truncateWithinMark = '_1smjoa19-3-5-0';
export var value = '_1smjoa11-3-5-0';
export var virtualizedSuggestion = '_1smjoa12-3-5-0';